module.exports = __webpack_public_path__ + "static/media/yes.760baf2a.svg";